/* eslint-disable */
import { ifMobile, isTablet } from "./chc/helpers";

document.addEventListener("alpine:init", () => {

    Alpine.data("background", (props) => {
        return {
            ...props,
            deviceType: "desktop",
            deviceWidth: window.innerWidth,
            get breakpointDeviceType() {
                return this.deviceWidth >= 768 ? "desktop" : "mobile";
            },
            init() {
                window.addEventListener("resize", () => {
                    this.deviceWidth = window.innerWidth;
                });
            },
            setBg(desktopImg, mobileImg, tabletImg) {
                if (isTablet() && tabletImg) {
                    this.$el.style.backgroundImage = `url('${tabletImg || "#"}')`;
                    return;
                }

                this.$el.style.backgroundImage = ifMobile() ? `url('${mobileImg || "#"}')` : `url('${desktopImg || "#"}')`;
            },
            setBackgroundImage(desktopImg, mobileImg, tabletImg) {
                let timeout;
                this.setBg(desktopImg, mobileImg, tabletImg);

                if (desktopImg === mobileImg) return;

                window.addEventListener("resize", () => {
                    clearTimeout(timeout);
                    timeout = setTimeout(() => this.setBg(desktopImg, mobileImg, tabletImg), 100);
                });
            },
            getDeviceType() {
                const ua = navigator.userAgent;
                if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
                    return "tablet";
                }
                if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
                    return "mobile";
                }
                return "desktop";
            },
            setVideosrc() {
                const sources = this.$el.querySelectorAll("source");

                sources.forEach((source) => {
                    const src = source.dataset?.src;
                    const type = source.dataset?.type;

                    if (src) {
                        source.src = src;
                        source.type = type;
                        this.$el.load()
                    }
                });
            }
        }
    });

});